// extracted by mini-css-extract-plugin
export default {"AdditionalInfoContainer":"Signup_AdditionalInfoContainer__cRJhR","Link":"Signup_Link__5iIHD"};